import { Component, OnInit, input, inject } from '@angular/core';
import { ErrorMessageService } from '@app/shared/services/material-error-message.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'material-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule]
})
export class FormInputComponent implements OnInit {
    private errorMessageService = inject(ErrorMessageService);

    readonly control = input<FormControl>(undefined);
    readonly title = input<string>(undefined);

    ngOnInit() {
    }

    getError() {
        return this.errorMessageService.getErrorMessageUsingFormControl(this.control());
    }
}
